export const pageSizeOptions = [
    { label: "5", value: 5 },
    { label: "10", value: 10 },
    { label: "20", value: 20 },
];
export const getVisiblePages = (pageIndex, totalPages, maxPages = 5) => {
    const pages = [];
    const nextPageNumber = pageIndex + 2;
    const startPage = nextPageNumber > maxPages && totalPages > maxPages
        ? totalPages < nextPageNumber
            ? totalPages - maxPages + 1
            : nextPageNumber - maxPages + 1
        : 1;
    for (let i = 0; i < maxPages; i++) {
        if (i + startPage > totalPages)
            break;
        pages.push(i + startPage);
    }
    return pages;
};
//# sourceMappingURL=FTLTableFooterModel.js.map